import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { PureComponent } from 'react';
import { tableClass } from './styles';

var Sorter =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Sorter, _PureComponent);

  var _super = _createSuper2(Sorter);

  function Sorter(props) {
    var _this;

    _classCallCheck(this, Sorter);

    _this = _super.call(this, props);
    _this.handleAsc = _this.handleAsc.bind(_assertThisInitialized(_this));
    _this.handleDesc = _this.handleDesc.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Sorter, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.defaultSorterOrder();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.defaultSorterOrder();
    }
  }, {
    key: "defaultSorterOrder",
    value: function defaultSorterOrder() {
      var _this$props = this.props,
          defaultOrder = _this$props.defaultOrder,
          _this$props$current = _this$props.current,
          current = _this$props$current === void 0 ? [] : _this$props$current,
          keyStr = _this$props.keyStr;
      if (current.length > 1) return;
      var item = current[0] || {};
      var changed = keyStr === item.key && defaultOrder === item.order;
      if (defaultOrder && !changed && !item.manual) this.handleChange(defaultOrder, false);
    }
  }, {
    key: "handleChange",
    value: function handleChange(order) {
      var manual = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var _this$props2 = this.props,
          sorter = _this$props2.sorter,
          keyStr = _this$props2.keyStr,
          onChange = _this$props2.onChange,
          _this$props2$current = _this$props2.current,
          current = _this$props2$current === void 0 ? [] : _this$props2$current;
      var item = current.find(function (v) {
        return v.key === keyStr;
      });
      var isCancel = !!item && order === item.order;
      var finalOrder = isCancel ? undefined : order;
      onChange(finalOrder, sorter, keyStr, order, manual);
    }
  }, {
    key: "handleAsc",
    value: function handleAsc() {
      this.handleChange('asc');
    }
  }, {
    key: "handleDesc",
    value: function handleDesc() {
      this.handleChange('desc');
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          _this$props3$current = _this$props3.current,
          current = _this$props3$current === void 0 ? [] : _this$props3$current,
          keyStr = _this$props3.keyStr,
          renderSorter = _this$props3.renderSorter;
      var item = current.find(function (v) {
        return v.key === keyStr;
      });
      var active = !!item;
      var isCustomRender = renderSorter && typeof renderSorter === 'function';
      return (
        /*#__PURE__*/
        React.createElement("div", {
          className: tableClass('sorter-container')
        }, isCustomRender ? renderSorter({
          status: active ? item.order : undefined,
          triggerAsc: this.handleAsc,
          triggerDesc: this.handleDesc
        }) :
        /*#__PURE__*/
        React.createElement(React.Fragment, null,
        /*#__PURE__*/
        React.createElement("a", {
          key: "asc",
          className: tableClass(active && item.order === 'asc' && 'sorter-active', 'sorter-asc'),
          onClick: this.handleAsc
        }, "\xA0"),
        /*#__PURE__*/
        React.createElement("a", {
          key: "desc",
          className: tableClass(active && item.order === 'desc' && 'sorter-active', 'sorter-desc'),
          onClick: this.handleDesc
        }, "\xA0")))
      );
    }
  }]);

  return Sorter;
}(PureComponent);

export default Sorter;